import { writable } from 'svelte/store';

let milkOptionsObj = {
    "uhtmilk": {
        name: "H-Milch",
        options: [
            {
                code: "uhtPure",
                name: "Milch",
                pricePerDay: 0.45,
                imgName: "uht_schulmilch"
            },{
                code: "uhtChoco",
                name: "Kakao",
                pricePerDay: 0.48,
                imgName: "uht_choco",
            },{
                code: "uhtVanilla",
                name: "Vanillemilch",
                pricePerDay: 0.48,
                imgName: "uht_vanilla",
            },{
                code: "uhtStrawberry",
                name: "Erdbeermilch",
                pricePerDay: 0.48,
                imgName: "uht_strawberry",
            }
        ]
    },
    "freshmilk": {
        name: "Frischmilch",
        options: [
            {
                code: "pure",
                name: "Vollmilch",
                pricePerDay: 0.48,
                imgName: "schulmilch"
            },{
                code: "choco",
                name: "Schokomilch",
                pricePerDay: 0.53,
                imgName: "schokomilch",
            }
        ]
    }
}


const milkOptionsStore = writable(milkOptionsObj);


export default milkOptionsStore;